import { createGlobalStyle } from 'styled-components'
import { normalize } from 'styled-normalize'
import theme from 'ui-components/lib/theme'
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import '@fontsource/montserrat/900.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

const GlobalStyles = createGlobalStyle`
  ${normalize}
  
  :root {
    /* Tema Claro - Cores do projeto atual */
    --bg-color: #FFFFFF;
    --text-color: #4E4B59;
    --text-secondary: #9997A0;
    --text-muted: #9997A0;
    --text-black: #000000;
    --text-white: #FFFFFF;
    --red-bnz: #F14F5C;
    --purple-bnz: #7683F6;
    --blue-bnz: #2D4677;
    --blue-dark: #1A2C50;
    --button-demand-bg: #192c50;
    --purple-dark: #6741A3;
    --border-color: #D3D2D7;
    --card-bg: hsl(220, 14%, 99%);
    --card-border: hsl(220, 13%, 85%);
    --card-hover-bg: hsl(220, 14%, 98%);
    --table-row-zebra: hsl(220, 14%, 97%);
    --success-color: #44E47A;
    --success-hover: #3dcf6e;
    --dropzone-bg: #EAEAEA;
    --breadcrumb-border: #D3D2D7;
    --breadcrumb-text: #9997A0;
    --breadcrumb-icon: #000000;
    --plan-border: #085C6E;
    --plan-text: #085C6E;
    --sidebar-bg: #FFFFFF;
    --sidebar-border: hsl(220, 13%, 94%);
    --sidebar-icon: hsl(220, 15%, 25%);
    --sidebar-icon-active: hsl(217, 35%, 22%);
    --sidebar-hover-bg: hsl(220, 14%, 97%);
    --sidebar-text: hsl(220, 15%, 25%);
    --modal-bg: #FFFFFF;
    --overlay-bg: rgba(0, 0, 0, 0.5);
    --divider-color: #E0E0E0;
    --shadow-color: rgba(0, 0, 0, 0.1);
    --table-header-bg: hsl(220, 14%, 88%);
    --table-border-color: rgba(0, 0, 0, 0.08);
  }
  
  .dark {
    /* Tema Escuro - Baseado no projeto de referência */
    --bg-color: hsl(215, 35%, 12%);
    --text-color: hsl(210, 20%, 95%);
    --text-secondary: hsl(215, 15%, 65%);
    --text-muted: hsl(215, 15%, 65%);
    --text-black: hsl(210, 20%, 95%);
    --text-white: hsl(210, 20%, 98%);
    --red-bnz: #F14F5C;
    --purple-bnz: #7683F6;
    --blue-bnz: hsl(210, 80%, 55%);
    --blue-dark: hsl(210, 80%, 55%);
    --button-demand-bg: #7683F6;
    --purple-dark: #7683F6;
    --border-color: hsl(215, 25%, 22%);
    --card-bg: hsl(215, 30%, 16%);
    --card-border: hsl(215, 25%, 22%);
    --card-hover-bg: hsl(215, 30%, 18%);
    --table-row-zebra: hsl(215, 30%, 14%);
    --success-color: #44E47A;
    --success-hover: #3dcf6e;
    --dropzone-bg: hsl(215, 25%, 20%);
    --breadcrumb-border: hsl(215, 25%, 22%);
    --breadcrumb-text: hsl(215, 15%, 65%);
    --breadcrumb-icon: hsl(210, 20%, 95%);
    --plan-border: hsl(210, 80%, 55%);
    --plan-text: hsl(210, 80%, 55%);
    --sidebar-bg: hsl(215, 35%, 10%);
    --sidebar-border: hsl(215, 25%, 18%);
    --sidebar-icon: hsl(210, 20%, 90%);
    --sidebar-icon-active: hsl(210, 80%, 55%);
    --sidebar-hover-bg: hsl(215, 25%, 20%);
    --sidebar-text: hsl(210, 20%, 90%);
    --modal-bg: hsl(215, 30%, 16%);
    --overlay-bg: rgba(0, 0, 0, 0.7);
    --divider-color: hsl(215, 25%, 22%);
    --shadow-color: rgba(0, 0, 0, 0.3);
    --table-header-bg: hsl(215, 25%, 10%);
    --table-border-color: rgba(255, 255, 255, 0.08);
  }
  
  :root {
    --table-header-bg: hsl(220, 14%, 85%);
  }
  
  html,body {
    height: 100%;
    margin: 0;
    padding: 0;
    font-family: ${theme.fontFamily}, Roboto, Montserrat, Inter;
    background-color: var(--bg-color);
    color: var(--text-color);
    transition: background-color 0.3s ease, color 0.3s ease;
  }
  body {
    font-family: ${theme.fontFamily}, Roboto, Montserrat, Inter;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  #root {
    height: 100%;
  }
  #root > div {
    height: 100vh;
  }

  /* Toast (react-toastify) - tema escuro */
  .dark {
    --toastify-color-light: hsl(215, 30%, 16%);
    --toastify-text-color-light: hsl(210, 20%, 95%);
    --toastify-toast-background: hsl(215, 30%, 16%);
    --toastify-color-dark: hsl(215, 30%, 16%);
    --toastify-text-color-dark: hsl(210, 20%, 95%);
  }

  .dark .Toastify__toast {
    background: var(--card-bg);
    color: var(--text-color);
    box-shadow: 0 4px 16px var(--shadow-color);
  }

  .dark .Toastify__toast-body {
    color: var(--text-color);
  }

  .dark .Toastify__progress-bar {
    background: var(--purple-bnz);
  }

  /* AlertStack (showMessage / ui-components) - tema escuro */
  .dark #root-alert-stack > div {
    background: var(--card-bg) !important;
    box-shadow: 0 4px 16px var(--shadow-color) !important;
    border-color: var(--border-color) !important;
  }

  .dark #root-alert-stack > div > div {
    background: var(--card-bg) !important;
    border-color: var(--border-color) !important;
    color: var(--text-color) !important;
  }

  .dark #root-alert-stack p {
    color: var(--text-color) !important;
  }

  .dark #root-alert-stack h4,
  .dark #root-alert-stack h5,
  .dark #root-alert-stack h6 {
    color: var(--text-color) !important;
  }
`

export default GlobalStyles
